import { useRef } from 'react';

import useWebSocket from 'hooks/useBentoStream/hooks/useWebSocket';
import useWebSocketErrorHandler from 'hooks/useBentoStream/hooks/useWebSocketErrorHandler';

const useBentoStream = () => {
  const { connectToRoom } = useWebSocket();
  const handleWebSocketError = useWebSocketErrorHandler();
  const roomConnectionRef = useRef();

  /**
   * @param {string} cartSlug
   */
  const getRoomConnection = async cartSlug => {
    if (!cartSlug) {
      return;
    }

    try {
      roomConnectionRef.current = await connectToRoom(cartSlug);
    } catch (error) {
      handleWebSocketError(error);
    }
  };

  const disconnectFromRoom = () => {
    if (roomConnectionRef.current) {
      // Disconnection also unsubscribes from all events
      roomConnectionRef.current.disconnect();
    }
  };

  const subscribeToEvent = (eventName, onEvent) => {
    if (roomConnectionRef.current) {
      roomConnectionRef.current.subscribe(eventName, onEvent);
    }
  };

  return {
    getRoomConnection,
    disconnectFromRoom,
    subscribeToEvent
  };
};

export default useBentoStream;
